import React from 'react';
import {Doughnut} from "react-chartjs-2";
import ChartDataLabels from 'chartjs-plugin-datalabels';
import './Chart.css';

const PieChart = ({data, options}) => {    
   
    return (
        <> 
            <Doughnut data={data} options={options} plugins={[ChartDataLabels]}/>
        </>
    )
}

export default PieChart;
